import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Helping from "../../helpers/Helping";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import Notification from "../layout/Notification";
import { create, update } from "../../services/badges.service";
import "react-sweet-progress/lib/style.css";
import { MESSAGE } from "../../config/index";
import LoadingButton from "../fields/LoadingButton";
import { Progress } from 'react-sweet-progress';
import { API_URL } from '../../config/urls';
import $ from 'jquery';
const { CREATE, UPDATE } = MESSAGE;

class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: API_URL.ADMIN_COLLECTION_API + "badge",
            pageTitle: "Add new badge",
            buttonTitle: "Save",
            name: "",
            logo: "",
            grey_logo: "",
            routeName: "",
            isLoading: true,
            btnIsDisable: false,
        };

        this.onUpdate = this.onUpdate.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handleValueChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "name") this.setState({ ...await validateField("string", name, value, "") });
        if (name === "logo") this.setState({ ...await validateField('file', name, e, "image", 1, 'logo', {}, false, "collections/badges/") });
        if (name === "grey_logo") this.setState({ ...await validateField('file', name, e, "image", 1, 'grey logo', {}, false, "collections/badges/") });
    }

    componentDidMount() {
        let that = this;
        this.setErrorOnApiCall();

        if (!this.props.id) {
            this.setState({
                isLoading: false
            });
        }

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.setState({
                pageTitle: "Add new badge",
                buttonTitle: 'Save'
            })
            that.props.closeEditModal();
        });
        if (this.props.id) {
            let id = this.props.id;

            that.setState({
                pageTitle: 'Edit Badge',
                buttonTitle: 'Update'
            });
            that.getById(id);
        }
    }

    getById(id) {
        var $this = this;
        axios
            .get(this.state.url + `/${id}`, Helping.getConfig())
            .then(response => {
                let { payload } = response.data;
                $this.setState({
                    name: payload.name,
                    logo: payload.logo,
                    grey_logo: payload.grey_logo,
                    isLoading: false
                });
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    $this.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        isLoading: false
                    });
                }
            });
    }

    resetForm = () => {
        this.setState({
            name: "",
            logo: "",
            grey_logo: "",
            btnIsDisable: false,
            error_name_message: "",
            error_logo_message: "",
            error_grey_logo_message: ""
        },
            () => this.scrollToTop());
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false;

        if (Number(state.name.length) === 0) {
            let errorObject = setErrorFields("name", "Name should not be empty.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.logo === "") {
            let errorObject = setErrorFields("logo", "Logo is required.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.grey_logo === "") {
            let errorObject = setErrorFields("grey_logo", "Grey Logo is required.");
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    removeImage = (name, id) => {
        $(`#${id}`).val('');

        this.setState({ [name]: "", [`${name}Percent`]: 0 });
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    onSave(e) {
        e.preventDefault();

        let self = this;
        let state = this.state;
        let formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            name: state.name,
            logo: state.logo,
            grey_logo: state.grey_logo
        };
        axios
            .post(API_URL.ADMIN_COLLECTION_API + "create-badge/", data, Helping.getConfig())
            .then(response => {
                self.props.create(response.data.payload);
                self.setState(
                    {
                        error_message: Helping.getMessageString(CREATE, "badge"),
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetForm() }
                );
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    self.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); });
                }
            });
    }

    onUpdate(e) {
        e.preventDefault();

        let self = this,
            state = this.state,
            id = this.props.id,
            formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            id: id,
            name: state.name,
            logo: state.logo,
            grey_logo: state.grey_logo
        };
        axios.post(API_URL.ADMIN_COLLECTION_API + "update-badge/", data, Helping.getConfig())
            .then(response => {
                self.props.update(response.data.payload);
                self.setState(
                    {
                        error_message: Helping.getMessageString(UPDATE, "badge"),
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetForm() }
                );
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    self.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); });
                }
            });
    }

    render() {
        return (
            <div class="addButton-slide right-slider addNew-badge">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">{Helping.getTitleCase(this.state.pageTitle)}</h4>
                        <span class="caption">Add badge information into system.</span>
                    </div>
                    {/* <span class="close-slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </span> */}
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form action="" class="info">
                    <div class="form-group">
                        <label for="badgeName">Name</label>
                        <input type="text" class={`form-control ${this.state.error_name_message ? 'error-input' : ''}`} name="name" id="badgeName" value={this.state.name} onChange={(e) => this.handleValueChange(e)} />
                        <span className="error-msg">{this.state.error_name_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Upload Logo File</label>
                        <div class={`ImgField ${this.state.error_logo_message ? 'error-input' : ''}`}>

                            {this.state.logo &&
                                <div className="img-holder">
                                    <span class="remove-img" title="Remove Logo" onClick={() => this.removeImage('logo', 'logoFile')}>&times;</span>
                                    <img src={this.state.logo} />
                                </div>
                            }
                            <label class="imgFieldArea" for="logoFile">
                                {!this.state.logo &&
                                    <span class="icon fileImg">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                            <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                        </svg>
                                    </span>
                                }
                                Click or drag and drop Image here
                            </label>
                            <input type="file" name="logo" id="logoFile" class="imgFieldInput" onChange={(e) => this.handleValueChange(e)} />
                        </div>
                        <span className="error-msg">{this.state.error_logo_message}</span>

                        {this.state.logoPercent > 0 && (
                            <Progress percent={this.state.logoPercent} />
                        )}
                        <a class="link mt-2" href={this.state.logo} target="_blank">{this.state.logo} </a>
                    </div>
                    <div class="form-group">
                        <label for="">Upload Gray Logo File</label>

                        <div class={`ImgField ${this.state.error_grey_logo_message ? 'error-input' : ''}`}>
                            {this.state.grey_logo &&
                                <div className="img-holder">
                                    <span class="remove-img" title="Remove Gray Logo" onClick={() => this.removeImage('grey_logo', 'greyLogoFile')}>&times;</span>
                                    <img src={this.state.grey_logo} />
                                </div>
                            }
                            <label class="imgFieldArea" for="greyLogoFile">
                                {!this.state.grey_logo &&
                                    <span class="icon fileImg">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                            <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                        </svg>
                                    </span>
                                }
                                Click or drag and drop Image here
                            </label>
                            <input type="file" name="grey_logo" id="greyLogoFile" class="imgFieldInput" onChange={(e) => this.handleValueChange(e)} />
                        </div>
                        <span className="error-msg">{this.state.error_grey_logo_message}</span>

                        {this.state.grey_logoPercent > 0 && (
                            <Progress percent={this.state.grey_logoPercent} />
                        )}
                        <a class="link mt-2" href={this.state.grey_logo} target="_blank">{this.state.grey_logo} </a>
                    </div>

                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            {!this.props.id &&
                                <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>
                            }

                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                this.props.id ? (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                ) : (
                                    <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                                )}
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        badges: state.badges
    };
};

const mapDispatchToProps = {
    addCurrentRoute,
    create,
    update
};

export default connect(mapStateToProps, mapDispatchToProps)(Create);
